import './App.css';
function App() {
    return (
        <div>
            <p>Coming Soon</p>
        </div>
    );
}

export default App;
